// #reagion FuelType

// Returns int value if param is a string
export const MapFuelTypeToInt = (value) => {
    switch (value) {
        case 'Benzine':
          return 1;
        case 'Hybride':
          return 2;
        case 'Diesel':
          return 3;
        case 'Elektrisch':
          return 4;
        default:
          return value;
      }
};

// #endregion FuelType

// #region GearboxType

// Returns int value if param is a string
export const MapGearboxTypeToInt = (stringValue) => {
    switch (stringValue) {
        case 'Automatisch':
          return 1;
        case 'Manueel':
          return 2;
        default:
          return stringValue;
      }
};

// #endregion GearboxType
